import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Form, FormButton, Margin, Panel, Text } from 'shared/components'

import * as styles from './styles'

const EditablePanelComponent = ({
  form,
  header,
  editable,
  onEdit,
  onCancel,
  onSave,
  className,
  children,
}) => (
  <Panel as={Form} form={form} onSubmit={onSave} className={className}>
    <header css={styles.header}>
      <Margin as={Text} right={1} size={18} bold>
        {header}
      </Margin>
      {editable ? (
        <>
          <Margin
            as={FormButton}
            plain
            submit
            right={1}
            title="Apply"
            css={styles.control}
          >
            <FontAwesomeIcon icon="check" css={styles.icon} />
          </Margin>
          <FormButton
            plain
            title="Cancel"
            css={styles.cancel}
            onClick={onCancel}
          >
            <FontAwesomeIcon icon="times" css={styles.icon} />
          </FormButton>
        </>
      ) : (
        <FormButton plain title="Edit" css={styles.control} onClick={onEdit}>
          <FontAwesomeIcon icon="pencil-alt" css={styles.icon} />
        </FormButton>
      )}
    </header>
    <Margin as="main" top={2}>
      {children(editable)}
    </Margin>
  </Panel>
)

EditablePanelComponent.propTypes = {
  className: PropTypes.string,
  form: PropTypes.shape().isRequired,
  header: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired,
  children: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default EditablePanelComponent
